/*
 * @Author: 李嘉宾 lijb@wisea.com.cn
 * @Date: 2024-08-23 13:58:18
 * @LastEditors: 李嘉宾 lijb@wisea.com.cn
 * @LastEditTime: 2024-09-10 16:14:50
 * @FilePath: \web\sznc_industry\public\js\api\szgx.js
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
 */
let Api = {
	"BTB_W_INDUSTRYARTICLEMAGE_FINDPAGELIST": "/b2b/w/industryArticleMage/findPageList", //分页查询列表
	"BTB_W_INDUSTRYARTICLEMAGE_SAVEORUPDATE": "/b2b/w/industryArticleMage/saveOrUpdate", //新增或修改
	"BTB_W_INDUSTRYARTICLEMAGE_FINDINFO": "/b2b/w/industryArticleMage/findInfo", //查询详细信息
	"BTB_W_INDUSTRYARTICLEMAGE_DEL": "/b2b/w/industryArticleMage/del", //删除
	"BTB_W_INDUSTRYARTICLECLASSMAGE_FINDPAGEINDUSTRYARTICLECLASSMAGETREE": "/b2b/w/industryArticleClassMage/findPageIndustryArticleClassMageTree", //分页查询文章分类树
	"BTB_W_INDUSTRYARTICLECLASSMAGE_SAVEORUPDATE": "/b2b/w/industryArticleClassMage/saveOrUpdate", //新增或修改
	"BTB_W_INDUSTRYARTICLECLASSMAGE_FINDINFO": "/b2b/w/industryArticleClassMage/findInfo", //查询详细信息
	"BTB_W_INDUSTRYARTICLECLASSMAGE_DEL": "/b2b/w/industryArticleClassMage/del", //删除
	"BTB_W_INDUSTRYARTICLECLASSMAGE_FINDINDUSTRYARTICLECLASSMAGETREE": "/b2b/w/industryArticleClassMage/findIndustryArticleClassMageTree", //查询基础品类树
  "BTB_W_INDUSTRYCOLUMNMANAGE_FINDLIST": "/b2b/w/IndustryColumnManage/findList", //栏目管理查询列表
  "BTB_W_INDUSTRYCOLUMNMANAGE_FINDPAGELIST": "/b2b/w/IndustryColumnManage/findPageList", //栏目管理分页查询列表
  "BTB_W_INDUSTRYCOLUMNMANAGE_FINDINFO": "/b2b/w/IndustryColumnManage/findInfo", //栏目管理查询详细信息
  "BTB_W_INDUSTRYCOLUMNMANAGE_SAVEORUPDATE": "/b2b/w/IndustryColumnManage/saveOrUpdate", //栏目管理新增或修改
  "BTB_W_INDUSTRYCOLUMNMANAGE_DEL": "/b2b/w/IndustryColumnManage/del", //栏目管理逻辑删除
  "BTB_W_INDUSTRYMANGE_ENTPPORTALMAGE_FINDDEFAULT": "/b2b/w/IndustryMange/entpPortalMage/findDefault", //查询默认产业基本信息主题等
  "BTB_W_INDUSTRYMANGE_ENTPPORTALMAGE_SAVEORUPDATE": "/b2b/w/IndustryMange/saveOrUpdate", //新增或修改默认产业基本信息主题等
  "BTB_N_CODECBASE64": "/b2b/n/codecBase64", //生成二维码
  
  "PLATTHIRDCONFIG_GETINFOBYTYPE": "/system/w/platThirdConfig/getInfoByType", //根据类型查询信息
  "PLATTHIRDCONFIG_SAVE": "/system/w/platThirdConfig/save", //保存信息管理
  "B2B_ENTPPORTALMAGE_FINDDEFAULTE": "/b2b/w/manage/entpPortalMage/findDefault", //查询默认产业基本信息
  "B2B_MANAGE_SAVEORUPDATE": "/b2b/w/manage/saveOrUpdate", //产业基本信息新增或修改
  "B2B_W_MODULE_FINDPAGELIST": "/b2b/w/module/findPageList", //关于我们
  "B2B_W_MODULE_SAVEORUPDATE": "/b2b/w/module/saveOrUpdate", //关于我们新增或编辑
  "B2B_W_MODULE_DEL": "/b2b/w/module/del", //关于我们新增或编辑
  "B2B_W_MODULE_FINDINFO": "/b2b/w/module/findInfo", //关于我们模块内容详情
  "B2B_W_CONTENT_FINDLIST": "/b2b/w/content/findList", //关于我们内容管理图片视频列表
  "B2B_W_CONTENT_DEL": "/b2b/w/content/del", //关于我们内容管理图片视频列表 删除 
  "B2B_W_FRIEND_FINDPAGELIST": "/b2b/w/friend/findPageList", //友情链接
  "B2B_W_FRIEND_SAVEORUPDATE": "/b2b/w/friend/saveOrUpdate", //友情链接新增或编辑
  "B2B_W_FRIEND_DEL": "/b2b/w/friend/del", //友情链接删除
	"B2B_N_MANAGE_FINDDEFAULT": "/b2b/n/manage/findDefault", //查询默认产业基本信息
  
  
  "B2B_W_INDUSTRYARTICLEAUDITMAGE_FINDINFO": "/b2b/w/IndustryArticleAuditMage/findInfo", //查询文章是否发布默认
  "B2B_W_INDUSTRYARTICLEAUDITMAGE_UPDATE": "/b2b/w/IndustryArticleAuditMage/update", //查询文章是否发布修改
  "B2B_W_INDUSTRYARTICLEMAGE_AUDIT": "/b2b/w/industryArticleMage/audit", //文章审核
  
  "B2B_W_INDUSTRYCERTIFICATION_FINDPAGELIST": "/b2b/w/IndustryCertification/findPageList", //商务资质列表
  "B2B_W_INDUSTRYCERTIFICATION_SAVEORUPDATE": "/b2b/w/IndustryCertification/saveOrUpdate", //商务资质新增
  "B2B_W_INDUSTRYCERTIFICATION_DEL": "/b2b/w/IndustryCertification/del", //商务资质删除

  
	"B2B_W_INDUSTRYNAVIGATE_FINDPAGELIST": "/b2b/w/industryNavigate/findPageList", //导航管理
	"B2B_W_INDUSTRYNAVIGATE_SAVEORUPDATE": "/b2b/w/industryNavigate/saveOrUpdate", //导航管理新增编辑
	"B2B_W_INDUSTRYNAVIGATE_FINDLIST": "/b2b/w/industryNavigatefindList", //导航管理查询列表
	"B2B_W_INDUSTRYNAVIGATE_DEL": "/b2b/w/industryNavigate/del", //导航管理删除
	"B2B_W_INDUSTRYNAVIGATE_FINDINFO": "/b2b/w/industryNavigate/findInfo", //导航管理详情

  //系统入口
  "B2B_W_SYSENTER_FINDPAGELIST": "/b2b/w/IndustrySystemEntry/findPageList", //系统入口查询列表
  "B2B_W_SYSENTER_SAVEORUPDATE": "/b2b/w/IndustrySystemEntry/saveOrUpdate", //新增或修改
  "B2B_W_SYSENTER_DEL": "/b2b/w/IndustrySystemEntry/del", //逻辑删除

  "B2B_W_PRODUCT_FINDPAGELIST": "/b2b/w/product/findPageList", //分页查询商品列表
	"SZGX_W_PRODUCT_RELEASE": "/b2b/w/product/release", //商品发布
	"B2B_W_PRODUCT_FINDINFO": "/b2b/w/product/findInfo", //查询商品详情
	"B2B_W_PRODUCT_PRODUCTAUDIT": "/b2b/w/product/productAudit", //审核商品
	"B2B_W_SHOPPRODUCTAUDIT_FINDPAGELIST": "/b2b/w/ShopProductAudit/findPageList", //分页查询列表
	"B2B_W_SHOPINFO_FINDSHOPLIST": "/b2b/w/shopInfo/findShopList", //查询商家列表
	"B2B_W_SHOPPRODUCTAUDIT_SAVEORUPDATE": "/b2b/w/ShopProductAudit/saveOrUpdate", //新增无需审核商品商家
	"B2B_W_SHOPPRODUCTAUDIT_DEL": "/b2b/w/ShopProductAudit/del", //删除无需审核商品商家
	"B2B_W_PRODUCT_BATCHSTATUS": "/b2b/w/product/batchStatus", //商品批量上架下架退场或着违规下架
	"B2B_W_PRODUCT_FINDPRODUCTOPREATEINFO": "/b2b/w/product/findProductOpreateInfo", //获取审核记录
  "ENTPBASEMAGE_FINDLIST":"/difam/w/entpBaseMage/findList",//基地查询列表

  "STAT_ORDEROVERVIEW": "/b2b/w/stat/orderOverview", //交易总览
	"STAT_ORDERCHANGE": "/b2b/w/stat/orderChange", //订单变化趋势
	"STAT_ORDERPAYANALYSE": "/b2b/w/stat/orderPayAnalyse", //订单支付分析
	"STAT_ORDERSALEPAGELIST": "/b2b/w/stat/orderSalePageList", //交易分析报表

	"SYSTEM_N_ACTIVECUSTOMERS": "/system/n/activeCustomers", //交易分析报表

  
	"SZGX_W_PRODUCT_EXPORTPRODUCT": "/b2b/w/product/exportProduct", //商品导出
	"B2B_W_BACKLOG_BACKLOG": "/b2b/w/backlog/backlog", //待办任务  

  
}
module.exports = Api